import { Controller } from 'react-hook-form';
import { DatePicker, DatePickerProps } from 'antd';
import { FormLabel } from '@src/components/ui';
import { ICommonFormProps } from '../DynamicForm.types';

export const FormSingleDatePicker = (props: ICommonFormProps) => {
    const {
        label,
        keyName,
        control,
        className = '',
        defaultValue,
        formProps = {},
    } = props;

    const {
        className: inputClassName = '',
        size,
        disabled,
        placeholder,
        format,
        allowClear,
        bordered,
        status,
        showTime,
        picker,
        inputReadOnly,
    } = formProps;

    const safeDatePickerProps: Partial<DatePickerProps> = {
        size,
        disabled,
        placeholder,
        format,
        allowClear: allowClear ?? false,
        bordered,
        status,
        showTime,
        picker,
        inputReadOnly,
    };

    return (
        <div className={className}>
            {label && <FormLabel label={label} />}
            <Controller
                control={control}
                name={keyName}
                defaultValue={defaultValue}
                render={({
                    field: { onChange, value, ...restField },
                    fieldState: { error },
                }) => {
                    return (
                        <>
                            <DatePicker
                                {...restField}
                                {...safeDatePickerProps}
                                value={value}
                                onChange={onChange}
                                className={`w-full ${inputClassName}`}
                            />
                            {error?.message && (
                                <div className="text-red-500 text-sm mt-0">
                                    {error.message}
                                </div>
                            )}
                        </>
                    );
                }}
            />
        </div>
    );
};
